
var daysNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

window.getBrowserLanguageRaw = () => navigator.language;

//This function is called in the Screens so we can fetch name of weekdays and months
function setCalendarLanguage(language) {

    try {
        moment.locale(language);
        var daysLocale = moment.weekdays(false);
        var monthsLocale = moment.months(false);

        //These are used in screen clock
        daysNames = daysLocale;
        monthNames = monthsLocale;
    } catch (e) {
        console.log(e);
    }
}


//We receive Timestamps such as format: 2020-12-13T07:58:14.407+01:00, this parses it to 2020-12-13 07:58:14
function gridTimestampParse(t) {
    var str = t.substring(0, t.indexOf("."));
    str = str.replace("T", " ");
    str = str.replace("Z", " ");
    return str;
}

//Simply make single digits to two letter strings
function checkTime(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

function isEmptyOrSpaces(str) {
    if (str == null) {
        return true;
    }
    else {
        return str === null || str.match(/^ *$/) !== null;
    }
    
}

function GetBrowserTimeZone(arg) {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        return "America/New_York";
    }
    
}

function ReadRawInput(inputId) {
    try {
        return document.getElementById(inputId).value;
    } catch {
        return null;
    }
    
}

function SetRawInput(inputId, value) {
    try {
        document.getElementById(inputId).value = value;
    }
    catch (e) {
        console.log(e);
        console.log(inputId);
    }
    
}

function SetRawEl(inputId, value) {
    try {
        document.getElementById(inputId).innerHTML = value;
    }
    catch (e) {
        console.log(e);
        console.log(inputId);
    }

}

function ShowRawEl(inputId) {
    try {
        $('#' + inputId).show();
    }
    catch (e) {
    }
}
function HideRawEl(inputId) {
    try {
        $('#' + inputId).hide();
    }
    catch (e) {
    }
}

function SetRawDisable(inputId, state) {
    try {
        document.getElementById(inputId).disabled = state;
    }
    catch (e) {
    }
}

function SetFocusElement(id) {
    try {
        const element = document.getElementById(id);
        element.focus();
        return 1;
    } catch {
        
    }
    return 0;
}

function scrollTop(elementName) {
    console.log("scrolling");
    try {
        $("#" + elementName).scrollTop($("#" + elementName)[0].scrollHeight);
    }
    catch { }
}

function SetTypeaheadValue(typeaheadDivId, myVal) {
    console.log("SetTypeaheadValue: " + typeaheadDivId + " " + myVal);
    $('#' + typeaheadDivId + ' .typeahead').typeahead('val', myVal);
}

function GetTypeaheadValue(typeaheadDivId) {
    var data = $('#' + typeaheadDivId + ' .typeahead.tt-input').first().val();
  
    //console.log($('#' + typeaheadDivId + ' .typeahead.tt-input'));

    return data;
}

function ReadCheckbox(inputId,) {
    return document.getElementById(inputId).checked;
}

function WriteCheckbox(inputId, value) {
    // alert(inputId + " " + value);
    document.getElementById(inputId).checked = value;
}

function minimizeFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


var substringMatcher = function (strs) {
    
    return function findMatches(q, cb) {
        var matches, substringRegex;

        // an array that will be populated with substring matches
        matches = [];

        // regex used to determine if a string contains the substring `q`
        substrRegex = new RegExp(q, 'i');

        // iterate through the pool of strings and for any string that
        // contains the substring `q`, add it to the `matches` array
        $.each(strs, function (i, str) {
            if (substrRegex.test(str)) {
                matches.push(str);
            }
        });

        cb(matches);
    };
};

function setWebPageTitle(siteName) {
    document.title = siteName;
}


function upperCaseF(a) {
    setTimeout(function () {
        a.value = a.value.toUpperCase();
    }, 1);
}

function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


function getHourFormatFromMilliSeconds(millisec) {
    var seconds = (millisec / 1000).toFixed(0);
    var minutes = Math.floor(Number(seconds) / 60).toString();
    let hours;
    if (Number(minutes) > 59) {
        hours = Math.floor(Number(minutes) / 60);
        hours = (hours >= 10) ? hours : "0" + hours;
        minutes = (Number(minutes) - (hours * 60)).toString();
        minutes = (Number(minutes) >= 10) ? minutes : "0" + minutes;
    }

    seconds = Math.floor(Number(seconds) % 60).toString();
    seconds = (Number(seconds) >= 10) ? seconds : "0" + seconds;
    if (!hours) {
        hours = "00";
    }
    if (!minutes) {
        minutes = "00";
    }
    if (!seconds) {
        seconds = "00";
    }

    var retString = hours + ":" + minutes + ":" + seconds;

    if (retString == "00:0:00") {
        retString = "00:00:00";
    }

    return retString;

}

const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

function clearInputFile(f) {
    if (f.value) {
        try {
            f.value = ''; //for IE11, latest Chrome/Firefox/Opera...
        } catch (err) { }
        if (f.value) { //for IE5 ~ IE10
            var form = document.createElement('form'),
                parentNode = f.parentNode, ref = f.nextSibling;
            form.appendChild(f);
            form.reset();
            parentNode.insertBefore(f, ref);
        }
    }
}

function getBrowserName() {

    try {
        let userAgent = navigator.userAgent;
        let browserName;

        if (userAgent.match(/chrome|chromium|crios/i)) {
            browserName = "chrome";
        } else if (userAgent.match(/firefox|fxios/i)) {
            browserName = "firefox";
        } else if (userAgent.match(/safari/i)) {
            browserName = "safari";
        } else if (userAgent.match(/opr\//i)) {
            browserName = "opera";
        } else if (userAgent.match(/edg/i)) {
            browserName = "edge";
        } else {
            browserName = "No browser detection";
        }

        return browserName;
    } catch (e) {
        
    }
    return "";
}

function getBrowserUserAgent() {

    try {
        var userAgent = navigator.userAgent;
        return userAgent;
    } catch (e) {

    }
    return "";
}

function getBrowserDims() {

    try {
        var win = window,
            doc = document,
            docElem = doc.documentElement,
            body = doc.getElementsByTagName('body')[0],
            x = win.innerWidth || docElem.clientWidth || body.clientWidth,
            y = win.innerHeight || docElem.clientHeight || body.clientHeight;
        return " size: " + x + "x" + y;
    } catch (e) {

    }
    return "";
}



function isInReleaseMode() {
    return release;
}

function toggleFullScreen(elem) {
    // ## The below if statement seems to work better ## if ((document.fullScreenElement && document.fullScreenElement !== null) || (document.msfullscreenElement && document.msfullscreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
    if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
        if (elem.requestFullScreen) {
            elem.requestFullScreen();
        } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullScreen) {
            elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
        }
    } else {
        if (document.cancelFullScreen) {
            document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    }
}

function ReloadPage(arg) {
    try {
        location.reload();
    } catch (e) {

    }
}


function jexcelDateTimeParse(line) {

    try {
        var ret = line;
        if (line == "") {
            ret = null;
        }
        else {
            // Put T and Z in datetime string to get DateTimeOffset format
            var s = line;
            var index = 10;

            s = s.substring(0, index) + 'T' + s.substring(index + 1);

            ret = s;
            ret += "Z";

            if (!isNaN(Date.parse(ret))) {
                var d = new Date(Date.parse(ret));
                if (d.getFullYear() > 3000) {
                    return null;
                }
                else {
                    return ret;
                }

            }
            else {
                return null;
            }
        }

        return ret;
    } catch (e) {
        return null;
    }
}

function timestampToJexcelDate(timestamp) {
    try {
        if (timestamp == null || timestamp == "") {
            return "";
        }
        else {
            var d = new Date(Date.parse(timestamp));

            var day = d.getDate();
            var month = d.getMonth() + 1;
            var year = d.getFullYear();
            var hour = d.getHours();
            var minute = d.getMinutes();
            var second = d.getSeconds();

            var dax = year + "-" + n2(month) + "-" + n2(day) + " " + n2(hour) + ':' + n2(minute) + ':' + n2(second);
            return dax;

        }
    } catch (e) {
        return "";
    }
}

function timestampToUsDate(timestamp) {
    try {
        if (timestamp == null || timestamp == "") {
            return "";
        }
        else {
            var jd = Date.parse(timestamp);
            var d = moment(jd);

            var day = new Date(jd).getDate();

            var dax = d.format('MMMM') + ' ' + day + ', ' + d.format('YYYY hh:mm A');



            return dax;

        }
    } catch (e) {
        return "";
    }
}

function timestampToUsShortColDate(timestamp) {
    try {
        if (timestamp == null || timestamp == "") {
            return "";
        }
        else {
            var jd = Date.parse(timestamp);
            var d = moment(jd);

            var day = new Date(jd).getDate();

            var dax = d.format('MMM') + '-' + day + '-' + d.format('YYYY');

            return dax;

        }
    } catch (e) {
        return "";
    }
}


function timestampToJexcelDateShort(timestamp) {
    try {
        if (timestamp == null || timestamp == "") {
            return "";
        }
        else {
            var d = new Date(Date.parse(timestamp));

            var day = d.getDate();
            var month = d.getMonth() + 1;
            var year = d.getFullYear();

            var dax = n2(month) + "/" + n2(day) + "/" + year;
            return dax;

        }
    } catch (e) {
        return "";
    }
}

function n2(n) {
    return n > 9 ? "" + n : "0" + n;
}


function openPwaDocument(title, fileName, folder, ext, url) {
    window.location = url;
}

let userScrolling = false;
let clickLock = false;
let scrollTimeout;

// Scroll smoothly to a section in the content pane (ONLY the content container)
function scrollToSection(id) {
    clickLock = true;

    const container = document.querySelector(".blz-settings-content");
    const el = document.getElementById(id);

    if (container && el) {
        // Compute el position relative to container
        const cRect = container.getBoundingClientRect();
        const eRect = el.getBoundingClientRect();

        const ACTIVATION_OFFSET = 12; // match what you use in observeSections
        const top = container.scrollTop + (eRect.top - cRect.top) - ACTIVATION_OFFSET;

        container.scrollTo({ top, behavior: "smooth" });
    }

    // Release lock after a short delay
    setTimeout(() => (clickLock = false), 350);
}

let __settingsObserver = null;
let __settingsDotNetRef = null;

function observeSections(dotNetRef) {
    const container = document.querySelector(".blz-settings-content");
    if (!container) return;

    // IMPORTANT: only sections INSIDE the container
    const sections = Array.from(container.querySelectorAll(".blz-settings-section"));
    if (!sections.length) return;

    // Clean up old observer (prevents duplicated callbacks)
    if (__settingsObserver) __settingsObserver.disconnect();

    __settingsDotNetRef = dotNetRef;

    // Pick the "current" section as the one most visible in the container
    const visible = new Map(); // id -> intersectionRatio

    __settingsObserver = new IntersectionObserver((entries) => {
        if (clickLock) return;

        for (const e of entries) {
            visible.set(e.target.id, e.isIntersecting ? e.intersectionRatio : 0);
        }

        // Find the section with the highest visibility ratio
        let bestId = null;
        let bestRatio = 0;

        for (const [id, ratio] of visible.entries()) {
            if (ratio > bestRatio) {
                bestRatio = ratio;
                bestId = id;
            }
        }

        if (bestId) {
            __settingsDotNetRef.invokeMethodAsync("UpdateActiveSection", bestId);
            // if you have this function:
            // ensureListItemVisible(bestId);
        }
    }, {
        root: container,
        // Tune these to decide when a section "counts" as active.
        // This says: treat the top ~25% of container as the "reading line".
        rootMargin: "-25% 0px -65% 0px",
        threshold: [0, 0.05, 0.1, 0.2, 0.3, 0.4, 0.5, 0.75, 1]
    });

    sections.forEach(s => __settingsObserver.observe(s));
}

// Keep the active list item visible in the sidebar
function ensureListItemVisible(sectionId) {
    // Find the currently selected MudListItem
    const active = document.querySelector(".blz-settings-list-item.mud-selected, .blz-settings-list-item.mud-selected-item");
    if (!active) return;

    // Find the scrollable container (the sidebar list)
    const list = document.querySelector(".blz-settings-list");
    if (!list) return;

    const listRect = list.getBoundingClientRect();
    const itemRect = active.getBoundingClientRect();

    // If the item is out of view, scroll it smoothly into view
    if (itemRect.top < listRect.top || itemRect.bottom > listRect.bottom) {
        active.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
}

function extractSectionTexts() {
    const sections = document.querySelectorAll(".blz-settings-section");
    const result = [];
    sections.forEach(sec => {
        const id = sec.id;
        // Collect all visible text (no tags, no script/style content)
        const text = sec.innerText || sec.textContent || "";
        result.push({ id, text: text.trim() });
    });
    return result;
}

function addBodyClass(cls) {
    document.body.classList.add(cls);
}
function removeBodyClass(cls) {
    document.body.classList.remove(cls);
}

function downloadFileGeneric(fileName, base64Data) {
    const link = document.createElement('a');
    link.download = fileName;
    link.href = 'data:image/png;base64,' + base64Data;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

